import {useDetached, Options} from './useDetached';

export function useDetachedFetch<Payload>(input: RequestInfo, init?: RequestInit, options?: Options<Payload>) {
    async function executer(input: RequestInfo, init?: RequestInit) {
        return await fetch(input, init);
    }

    return useDetached(executer, {...options, initialState: undefined}, input, init);
}
